function expireCreditVerification(paymentsInfo) {
  const now = new Date().getTime();
  const creditInfo = paymentsInfo?.creditVerification?.verifiedDate;
  const creditVerifiedDate = new Date(creditInfo || now);
  creditVerifiedDate.setDate(creditVerifiedDate.getDate() + 30);
  const isValid = now < creditVerifiedDate.getTime();
  if (!isValid) {
    paymentsInfo.creditVerification = {};
  }
}
export { expireCreditVerification as default };
